/**
 * @file Work slip head
 * @author Heino Lenting
 */
import { BrandingService } from '../../core/branding.service';
import { SettingsService } from '../../settings.service';
var WorkSlipHeadComponent = /** @class */ (function () {
    /**
     * Constructs a HeaderComponent
     * @param brandingService Customer specific branding
     */
    function WorkSlipHeadComponent(brandingService, settingsService) {
        this.brandingService = brandingService;
        this.addressLines = [];
        // Load address from settings
        if (settingsService.settings.frontend.workslip && settingsService.settings.frontend.workslip.address) {
            this.addressLines = settingsService.settings.frontend.workslip.address;
        }
    }
    return WorkSlipHeadComponent;
}());
export { WorkSlipHeadComponent };
